import type { Document } from "@models";
import { isDidReference } from "./constants";
import { getContextLabel } from "./context-labels";
import { getDocumentReferenceOptions } from "./document-reference";
import type { DynamicNodeOption } from "./dynamic-node-context";

/** Scalar context variables plus selectable document references. */
export const toContextOptions = (
  contextValues: Record<string, unknown>,
  documents: readonly Document[] = [],
  excludedDocumentId?: string
): DynamicNodeOption[] => {
  const contextOptions = Object.entries(contextValues).flatMap(
    ([key, value]) =>
      value === null ||
      value === undefined ||
      typeof value === "object" ||
      isDidReference(key)
        ? []
        : [{ key, label: getContextLabel(key) }]
  );

  return [
    ...contextOptions,
    ...getDocumentReferenceOptions(
      contextValues,
      documents,
      excludedDocumentId
    ),
  ];
};
